import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function ScoreCommentView() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [testName, setTestName] = useState("");
  const [categoryName, setCategoryName] = useState("");

    const token = localStorage.getItem("admin_token");
  const base  = process.env.REACT_APP_API_BASE_URL;

  const pickName = (obj = {}) =>
    obj?.name ?? obj?.title ?? obj?.category_name ?? obj?.label ?? "";

  const normalizeArray = (d) =>
    Array.isArray(d) ? d
    : Array.isArray(d?.data) ? d.data
    : Array.isArray(d?.rows) ? d.rows
    : [];

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/score-comments/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
        );
        setData(res.data);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [id]);
  // 2) Test/Kategori adlarını çek (yorum geldikten sonra)
  useEffect(() => {
    if (!data) return;
    (async () => {
      try {
        // Test adı
        try {
          const { data: test } = await axios.get(`${base}/api/tests/${data.test_id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setTestName(pickName(test) || `Test #${data.test_id}`);
        } catch {
          setTestName(`Test #${data.test_id}`);
        }

        // Kategori adı (varsa)
        if (!data.category_id) {
          setCategoryName("");
          return;
        }

        let name = "";

        // 1) /api/categories/:id
        try {
          const { data: cat1 } = await axios.get(`${base}/api/categories/${data.category_id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          name = pickName(cat1) || name;
        } catch {}

        // 2) /api/test-categories/:id
        if (!name) {
          try {
            const { data: cat2 } = await axios.get(`${base}/api/test-categories/${data.category_id}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            name = pickName(cat2) || name;
          } catch {}
        }

        // 3) /api/tests/:testId/categories listesinden bul
        if (!name) {
          try {
            const { data: listRaw } = await axios.get(`${base}/api/tests/${data.test_id}/categories`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const list = normalizeArray(listRaw);
            const found = list.find(
              (c) =>
                String(c.id) === String(data.category_id) ||
                String(c.category_id) === String(data.category_id)
            );
            name = pickName(found) || name;
          } catch {}
        }

        setCategoryName(name || `Kategori #${data.category_id}`);
      } catch {
        // sessiz geç
      }
    })();
  }, [data, base, token]);

  if (!data) return <p className="text-center my-5">Yükleniyor…</p>;

  return (
    <div className="container my-4">
         {/* ▸ Context line */}
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="small text-muted">
          {data.category_id ? (
            <>
              Test: <strong>{testName }</strong>
              {" · "}
              Kategori: <strong>{categoryName }</strong>
            </>
          ) : (
            <>
              Test: <strong>{testName }</strong>
            </>
          )}
        </div>
      </div>
      <div className="card shadow-sm">
        <div className="card-header">
          <h5>Açıklama</h5>
        </div>
        <div className="card-body">
          <p>
            <strong>Aralık:</strong> {data.min_score} – {data.max_score}
          </p>
          <div className="mb-3">
            <strong>Özet:</strong>
            <div
              className="border p-2 rounded"
              dangerouslySetInnerHTML={{ __html: data.summary }}
            />
          </div>
          <div>
            <strong>Detay:</strong>
            <div
              className="border p-2 rounded"
              dangerouslySetInnerHTML={{ __html: data.details }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
